import { useSession } from "@/features/auth/context/session.context"
import { UserRole } from "@/shared/constants/user-roles"

/** Shown when sidebar / mobile nav links are disabled until Profile required fields are completed. */
export const PROFILE_NAV_LOCK_TOOLTIP = "Complete your Profile to continue"

/**
 * True when a volunteer or homeowner must finish Profile (currentStep === 1) before using the rest of the app.
 * Uses SessionContext profile, which is refreshed after successful profile saves.
 */
export function useNavLockedUntilProfileComplete(): boolean {
    const { session, profile, isLoading } = useSession()
    if (isLoading) return false
    if (!session?.sub) return false
    if (session.role !== UserRole.VOLUNTEER && session.role !== UserRole.HOMEOWNER) {
        return false
    }
    if (!profile) return false
    return profile.currentStep === 1
}
